import {
  RECEIVE_USERINFO,
  RECEIVE_USERBASEINFO,
  RECEIVE_COUPONAMOUNT,
  RECEIVE_ADDRESSINFO,
  RECEIVE_PASSENGERINFO,
  RECEIVE_PATIENTINFO,
  RECEIVE_EXPRESSINFO,
  RECEIVE_OTHERRINFO,
  RECEIVE_TICKETINFO,
  RECEIVE_ORDERINFO,
  RECEIVE_BALANCEPAY,
  RECEIVE_FEE,
  RECEIVE_EXPRESSTYPE,
  RECEIVE_ADDFEE,
  RECEIVE_DOCTORINFO,
  RECEIVE_HOSPITALINFO,
  RECEIVE_PAYTYPE,
  RECEIVE_BUDGET
} from './mutation-type'

export default {
  [RECEIVE_USERINFO] (state, userInfo) {
    state.userInfo = userInfo
  },
  [RECEIVE_USERBASEINFO] (state, userBaseInfo) {
    if (userBaseInfo.bool) {
      state.userBaseInfo.invoiceMoney = userBaseInfo.invoiceMoney
    } else {
      state.userBaseInfo = userBaseInfo
    }
  },
  [RECEIVE_COUPONAMOUNT] (state, amount) {
    state.amount = amount
  },
  [RECEIVE_ADDRESSINFO] (state, address) {
    state.address = address
  },
  [RECEIVE_PASSENGERINFO] (state, passengerInfo) {
    state.passengerInfo = passengerInfo
  },
  [RECEIVE_PATIENTINFO] (state, patientInfo) {
    state.patientInfo = patientInfo
  },
  [RECEIVE_EXPRESSINFO] (state, expressInfo) {
    state.expressInfo = expressInfo
  },
  [RECEIVE_TICKETINFO] (state, ticketInfo) {
    state.ticketInfo = ticketInfo
  },
  [RECEIVE_OTHERRINFO] (state, otherInfo) {
    state.otherInfo = otherInfo
  },
  [RECEIVE_ORDERINFO] (state, orderInfo) {
    state.orderInfo = orderInfo
  },
  // 支付
  [RECEIVE_BALANCEPAY] (state, balancePay) {
    state.balancePay = balancePay
  },
  // // 订单充值
  // [RECEIVE_ORDERINFO] (state, recharge) {
  //   state.recharge = recharge
  // },
  [RECEIVE_FEE] (state, fee) {
    state.fee = fee
  },
  [RECEIVE_BUDGET] (state, budget) {
    state.budget = budget
  },
  [RECEIVE_ADDFEE] (state, addFee) {
    state.addFee = addFee
  },
  [RECEIVE_EXPRESSTYPE] (state, expressType) {
    state.expressType = expressType
  },
  [RECEIVE_DOCTORINFO] (state, doctorInfo) {
    state.doctorInfo = doctorInfo
  },
  [RECEIVE_HOSPITALINFO] (state, hospitalInfo) {
    state.hospitalInfo = hospitalInfo
  },
  [RECEIVE_PAYTYPE] (state, payType) {
    state.payType = payType
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js